export default __webpack_public_path__ + "images/UN.eb3f7b3.png";